export default __webpack_public_path__ + "img/weeklyNews3.9244aaf0.jpg";